export default {
  data: ()=>({
    text: [
      {},
    ],
    themeData: window.themeData,
  }),
}
